var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61502 8.58301L8.34502 8.43801C8.19569 8.42047 8.04432 8.437 7.9023 8.48636C7.76028 8.53573 7.63128 8.61663 7.52502 8.72301L6.60502 9.64301C5.18572 8.92098 4.03205 7.76731 3.31002 6.34801L4.23502 5.42301C4.45002 5.20801 4.55502 4.90801 4.52002 4.60301L4.37502 3.34301C4.34678 3.09905 4.22975 2.87402 4.04625 2.71081C3.86275 2.54759 3.62561 2.45761 3.38002 2.45801H2.51502C1.95002 2.45801 1.48002 2.92801 1.51502 3.49301C1.78002 7.76301 5.19502 11.173 9.46002 11.438C10.025 11.473 10.495 11.003 10.495 10.438V9.57301C10.5 9.06801 10.12 8.64301 9.61502 8.58301Z",
    fill: "#6B778C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundPhone);
export default __webpack_public_path__ + "static/media/ic_round-phone.51ea4ec0567334dc398e4473d3701190.svg";
export { ForwardRef as ReactComponent };